import services from "../Constant/service";
import endpoint from "../Constant/endpoint";
import { showSuccessSnackbar } from "./snackbarAction";
import { showErrorSnackbar } from "./snackbarAction";
import { SET, UPDATE } from "../Types/courseTypes";
import { updateValues } from "./authAction";
import moment from "moment";

export const setParentCourse = (key, value) => (dispatch) => {
  dispatch({
    type: SET,
    payload: {
      [key]: value,
    },
  });
};

export const modifyParentCourse = (key, value) => (dispatch) => {
  dispatch({
    type: UPDATE,
    payload: {
      [key]: value,
    },
  });
};

export const getCampaignUserData = (callback) => async (dispatch, getState) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.campaignManagement.getCampaignUserData,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getQualifyExams = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.campaignManagement.getQualifyExams,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getQualifyYears = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.campaignManagement.getQualifyYears,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getCampaignImage = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("files", data);
  services.postUploadMedia(
    `${endpoint.campaignManagement.getCampaignImage}`,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getCampaignList =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.campaignManagement.getCampaignList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const getOfferVariableList =
  (callback) => async (dispatch, getState) => {
    dispatch(updateValues("loader", true));
    services.getApiCall(
      endpoint.campaignManagement.getOfferVariableList,
      "",
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          callback(res?.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const addMailCampaign = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.campaignManagement.addMailCampaign,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getListMailCampaign =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.campaignManagement.getListMailCampaign,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const deleteMailCampaignDataByID =
  (id, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.deleteApiCall(
      `${endpoint.campaignManagement.deleteMailCampaignDataByID}${id}`,
      "",
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(
            showSuccessSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
          );
          callback(true);
        } else {
          callback(false);
          dispatch(
            showErrorSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
          );
        }
      },
      (error) => {
        callback(false);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const getmailCampaignDetail = (id, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.campaignManagement.getmailCampaignDetail(`${id}`),
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const updateMailCampaign = (data, id, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    `${endpoint.campaignManagement.updateMailCampaign}${id}`,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getMailCampaigningList =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.campaignManagement.getMailCampaigningList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const mailPushNotification = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.campaignManagement.mailPushNotification,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        callback(res);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      callback(false);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const MailAnalysisList = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.campaignManagement.mailAnalysisList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const MailCampaignUserDetails = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.campaignManagement.mailCampaignUserDetails,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getCampaignDetailsByID = (id, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.campaignManagement.getCampaignDetailsByID(`${id}`),
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const addWhatsAppCampaign = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.campaignManagement.addWhatsAppCampaign,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getExamSectionList = (callback) => async (dispatch, getState) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.getResultCompilation.getExamSectionList,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getResultCompilationList =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.getResultCompilation.getResultCompilationList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
// export const getSundayTestWarningList =
//   (callback) => async (dispatch, getState) => {
//     dispatch(updateValues("loader", true));

//     services.getApiCall(
//       endpoint.sundayTest.getSundayTestWarningList,
//       "",
//       (res) => {
//         dispatch(updateValues("loader", false));

//         if (res?.data?.statusCode === services.status_code.success) {
//           callback(res?.data);
//         } else {
//           dispatch(showErrorSnackbar(res?.msg));
//         }
//       },
//       (error) => {
//         dispatch(updateValues("loader", false));
//       },
//     );
//   };
export const getSundayTestWarningList =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.sundayTest.getSundayTestWarningList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const unblockSundayTestWarning =
  (id, data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      `${endpoint.sundayTest.unblockSundayTestWarning}${id}`,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const importCampaignExcel = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("files", data);
  services.postUploadMedia(
    `${endpoint.campaignManagement.importCampaignExcel}`,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
